import NotFoundImg from '@assets/images/ai1.png';
import styles from './index.module.scss';

const EmptyStory = () => {
  return (
    <div className={styles['empty']}>
      <div className={styles['img']}>
        <img src={NotFoundImg} alt="Not Found" />
        <div className={styles['title']}>
          <p>No data</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyStory;
